<div class="container mainbox">
    <form [formGroup]="mainForm" *ngIf="loadData$ | async as data; else loading">
        <h1 class="form-group title-position" style="margin-top: 20px;" translate>promoCampaignConfig.title</h1>

        <!-- Main Section -->
        <div id="mainContent" role="tablist" aria-multiselectable="true">
            <div class="card">
                <div class="card-header" id="mainSection">
                    <h5 class="mb-0">
                        <button class="btn btn-link" data-toggle="collapse" data-target="#collapseMainSection"
                            aria-expanded="true" aria-controls="collapseMainSection" translate>
                            promoCampaignConfig.mainSection
                        </button>
                    </h5>
                </div>
                <div id="collapseMainSection" class="collapse show" aria-labelledby="mainSection" data-parent="#mainContent">
                    <div class="card-body">
                        <div class="container-fluid row">

                            <div class="col-lg-4 col-md-6">
                                <div style="width: 200pt">
                                    <label style="margin-top: 12px;" translate>promoCampaignConfig.service</label>
                                    <select class="custom-select input-custom-size" [compareWith]="compareByMobileAppId"
                                        formControlName="service"
                                        [ngClass]="{ 'is-invalid': showValidations && f.service.errors }">
                                        <option [ngValue]="null" disabled translate>placeholder.select</option>
                                        <option *ngFor="let s of additionalServices" [ngValue]="s">{{s.name}}</option>
                                    </select>
                                    <div class="invalid-feedback" *ngIf="f.service.errors?.required && showValidations" translate>errors.required</div>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6">
                                <div style="margin-top: 12px;">
                                    <label translate>promoCampaignConfig.isActive</label>
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input" id="isActiveSwitch" formControlName="isActive">
                                        <label class="custom-control-label" for="isActiveSwitch"></label>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6">
                                <div style="margin-top: 12px;">
                                    <label translate>promoCampaignConfig.hasPromoPrice</label>
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input" id="hasPromoPriceSwitch"
                                            formControlName="hasPromoPrice" (change)="onHasPromoPriceChange($event)">
                                        <label class="custom-control-label" for="hasPromoPriceSwitch"></label>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6">
                                <div style="margin-top: 12px;">
                                    <label translate>promoCampaignConfig.hasTrigger</label>
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input" id="hasTriggerSwitch"
                                            formControlName="hasTrigger">
                                        <label class="custom-control-label" for="hasTriggerSwitch"></label>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Promo Price Section -->
        <div id="accordion" *ngIf="f.hasPromoPrice.value">
            <div class="card">
                <div class="card-header" id="promoPriceSection">
                    <h5 class="mb-0">
                        <button class="btn btn-link" data-toggle="collapse" data-target="#collapsePromoPriceSection"
                            aria-expanded="true" aria-controls="collapsePromoPriceSection" translate>
                            promoCampaignConfig.promoPriceSection
                        </button>
                    </h5>
                </div>
                <div id="collapsePromoPriceSection" class="collapse show" aria-labelledby="promoPriceSection" data-parent="#accordion">
                    <div class="card-body">
                        <div class="container-fluid row">

                            <div class="col-lg-4 col-md-6">
                                <div style="width: 200pt">
                                    <label style="margin-top: 12px;" translate>promoCampaignConfig.discountKind</label>
                                    <select class="custom-select input-custom-size" formControlName="discountKind"
                                        [ngClass]="{ 'is-invalid': showValidations && f.discountKind.errors }">
                                        <option [ngValue]="null" disabled translate>placeholder.select</option>
                                        <option value="P" translate>promoCampaignConfig.discountPercent</option>
                                        <option value="V" translate>promoCampaignConfig.discountInValue</option>
                                    </select>
                                    <div class="invalid-feedback" *ngIf="f.discountKind.errors?.required && showValidations" translate>errors.required</div>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6">
                                <label style="margin-top: 12px;" translate>promoCampaignConfig.discountValue</label>
                                <input style="width: 200pt" type="number" class="form-control" formControlName="discountValue"
                                    placeholder="{{'placeholder.enter' | translate}}"
                                    [ngClass]="{ 'is-invalid': showValidations && f.discountValue.errors }">
                                <div class="invalid-feedback" *ngIf="f.discountValue.errors?.required && showValidations" translate>errors.required</div>
                                <div class="invalid-feedback" *ngIf="f.discountValue.errors?.min && showValidations" translate>errors.onlyPositiveNumbers</div>
                            </div>

                            <div class="col-lg-4 col-md-6">
                                <label style="margin-top: 12px;" translate>promoCampaignConfig.discountText</label>
                                <input style="width: 200pt" type="text" class="form-control" formControlName="discountText"
                                    placeholder="{{'placeholder.enter' | translate}}">
                            </div>

                            <div class="col-lg-4 col-md-6">
                                <label style="margin-top: 12px;" translate>promoCampaignConfig.discountTextColor</label>
                                <div class="d-flex align-items-center" style="width: 200pt">
                                    <input type="text" class="form-control" formControlName="discountTextColor"
                                        placeholder="#RRGGBB">
                                    <span class="ml-2 border" style="display: inline-block; width: 30px; height: 30px; min-width: 30px;"
                                        [style.background-color]="f.discountTextColor.value || '#ffffff'"></span>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Trigger Services Section -->
        <div id="accordion2" *ngIf="f.hasTrigger.value">
            <div class="card">
                <div class="card-header" id="triggerSection">
                    <h5 class="mb-0">
                        <button class="btn btn-link" data-toggle="collapse" data-target="#collapseTriggerSection"
                            aria-expanded="true" aria-controls="collapseTriggerSection" translate>
                            promoCampaignConfig.triggerSection
                        </button>
                    </h5>
                </div>
                <div id="collapseTriggerSection" class="collapse show" aria-labelledby="triggerSection" data-parent="#accordion2">
                    <div class="card-body">
                        <div formArrayName="triggerServices">
                            <div *ngFor="let ts of triggerServicesArray.controls; let i = index" [formGroupName]="i" class="container-fluid row mb-2">
                                <div class="col-lg-4 col-md-6">
                                    <div style="width: 200pt">
                                        <label style="margin-top: 12px;" translate>promoCampaignConfig.triggerService</label>
                                        <select class="custom-select input-custom-size" formControlName="mobileAppId"
                                            [ngClass]="{ 'is-invalid': showValidations && ts.get('mobileAppId')?.errors }"
                                            (change)="onTriggerServiceChange($event, i)">
                                            <option [ngValue]="null" disabled translate>placeholder.select</option>
                                            <option *ngFor="let s of additionalServices" [ngValue]="s.mobileAppId">{{s.name}}</option>
                                        </select>
                                        <div class="invalid-feedback" *ngIf="ts.get('mobileAppId')?.errors?.required && showValidations" translate>errors.required</div>
                                    </div>
                                </div>
                                <div class="col-lg-2 col-md-3 d-flex align-items-end">
                                    <button type="button" class="btn btn-danger" style="margin-top: 12px;" (click)="removeTriggerService(i)">
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="container-fluid row mt-2">
                            <div class="col-12">
                                <button type="button" class="btn btn-secondary" (click)="addTriggerService()">
                                    <i class="fa fa-plus"></i>&nbsp;<span translate>button.add</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </form>

    <!-- Save Button -->
    <div class="text-right" *ngIf="dataLoaded">
        <button class="btn btn-primary w-20" [disabled]="disableActionBtn" style="margin-top: 10px;" (click)="save()" translate>button.save</button>
    </div>

    <ng-container *ngIf="!disableActionBtn; else dataLoadingTemplate"></ng-container>

    <ng-template #loading>
        <div *ngIf="errorMessage$ | async as errorMessage; else spinner">
            <div class="alert alert-danger">
                {{errorMessage}}
            </div>
            <div class="d-flex justify-content-center">
                <i class="fa fa-refresh" (click)="reload()"></i>
            </div>
        </div>
        <ng-template #spinner>
            <div class="d-flex justify-content-center">
                <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </ng-template>
    </ng-template>
</div>

<ng-template #dataLoadingTemplate>
    <div *ngIf="errorMessage$ | async as errorMessage; else dataSpinner">
        <div class="alert alert-danger">
            {{errorMessage}}
        </div>
        <div class="d-flex justify-content-center">
            <i class="fa fa-refresh" (click)="reload()"></i>
        </div>
    </div>
    <ng-template #dataSpinner>
        <div class="d-flex justify-content-center">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </ng-template>
</ng-template>
